import { useState, useEffect } from 'react'
import { Switch, FormControlLabel, Button, Card, CardContent, Typography, Stack, Divider } from '@mui/material'
import { useSnackbar } from 'notistack'
import { settingsList, settingsUpdate } from 'models/settings'

const SettingsPage = () => {
    const { enqueueSnackbar } = useSnackbar()
    const [settings, setSettings] = useState({})
    const [loading, setLoading]   = useState(false)

    useEffect(() => {
        settingsList().then((res) => {
            const flat = {}
            Object.values(res.data).forEach((group) => {
                group.forEach((s) => { flat[s.key] = s })
            })
            setSettings(flat)
        })
    }, [])

    const handleToggle = (key, val) => {
        setSettings((prev) => ({
            ...prev,
            [key]: { ...prev[key], value: val },
        }))
    }

    const handleSave = async () => {
        setLoading(true)
        const payload = Object.values(settings).map((s) => ({
            key:   s.key,
            value: String(s.value),
        }))
        await settingsUpdate({ settings: payload })
            .then(() => enqueueSnackbar('Settings saved', { variant: 'success' }))
            .catch(() => enqueueSnackbar('Failed to save', { variant: 'error' }))
            .finally(() => setLoading(false))
    }

    return (
        <Card>
            <CardContent>
                <Typography variant="h4" mb={2}>Settings</Typography>
                <Divider sx={{ mb: 2 }} />

                <Stack spacing={2}>
                    {/* Order Settings */}
                    <Typography variant="h6" color="textSecondary">Order</Typography>

                    {settings['show_custom_time_option'] && (
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={Boolean(settings['show_custom_time_option']?.value)}
                                    onChange={(e) => handleToggle('show_custom_time_option', e.target.checked)}
                                    color="primary"
                                />
                            }
                            label={settings['show_custom_time_option']?.label}
                        />
                    )}
                </Stack>

                <Button
                    variant="contained"
                    sx={{ mt: 3 }}
                    onClick={handleSave}
                    disabled={loading}
                >
                    {loading ? 'Saving...' : 'Save Settings'}
                </Button>
            </CardContent>
        </Card>
    )
}

export default SettingsPage